import { useParams } from 'react-router-dom'
import { useNav } from '../../../hooks/useNav'
import AccountForm from './AccountForm'
import { accountKeys, MODE } from '../../../data/queryFactories'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { accountService } from '../../../service/AccountService'
import { showErrorToast, showSuccessToast } from '../../../utils/showToast'
import { accountGroupUsers } from '../../../service/AccountGroupUsers'
import useGetAccountByUUID from './hooks/useGetAccountById'

export default function EditAccountPopUp({ closePopUp, uuid }) {
  const navigate = useNav()
  const queryClient = useQueryClient()
  const dataAccount = useGetAccountByUUID(uuid)
  const editAccountMutation = useMutation({
    mutationFn: async (account) => {
      const currentGroupUuids = dataAccount?.data.groupUuids.map(
        (item) => item.uuid
      )
      const newGroupUuids = account.groupUuids
      // const same = newGroupUuids.filter((uuid) =>
      //   currentGroupUuids.includes(uuid)
      // )

      const added = []
      newGroupUuids
        .filter((uuid) => !currentGroupUuids.includes(uuid))
        .map((uuid) => {
          if (uuid) {
            added.push(uuid)
          }
        })
      const removed = []
      currentGroupUuids
        .filter((uuid) => !newGroupUuids.includes(uuid))
        .map((uuid) => {
          if (uuid) {
            removed.push(uuid)
          }
        })
      if (added.length > 0) {
        for (const groupUuid of added) {
          const { success, message } =
            await accountGroupUsers.addListUserToGroup({
              userUuids: Array(uuid),
              groupUuid: groupUuid,
            })
          if (!success) {
            throw new Error(message.content)
          }
        }
      }
      if (removed.length > 0) {
        for (const groupUuid of removed) {
          const { success, message } =
            await accountGroupUsers.removeListUserFromGroup({
              userUuids: Array(uuid),
              groupUuid: groupUuid,
            })
          if (!success) {
            throw new Error(message.content)
          }
        }
      }
      return { success: true, message: 'Thêm nhóm tài khoản thành công' }
    },
    onError: (error) => {
      showErrorToast({
        message: error.message || 'Cập nhật tài khoản thất bại',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accountKeys.all })

      showSuccessToast('Cập nhật tài khoản thành công')
      closePopUp()
    },
  })
  const { data, isLoading, error } = useGetAccountByUUID(uuid)
  if (isLoading) {
    return 'Đang tải'
  }
  if (error || !data) {
    return
  }
  return (
    <AccountForm
      mode={MODE.EDIT}
      initForm={{
        schoolId: data.schoolId,
        fullName: data.fullName,
        studentCourse: data.studentCourse,
        groupUuids: data.groupUuids.map((item) => item.uuid),
        personalEmail: data.personalEmail,
        schoolEmail: data.schoolEmail,
        phoneNumber: data.phoneNumber,
        className: data.className,
        faculty: '',
        school: '',
      }}
      submitHandler={(formData) => {
        editAccountMutation.mutate({
          ...data,
          ...formData,
          schoolId: formData.id,
          fullName: formData.name,
        })
      }}
      uuid={uuid}
      closePopUp={closePopUp}
    />
  )
}
